import { defineComponent as p, openBlock as t, createElementBlock as o, mergeProps as u, unref as e, renderSlot as m, createElementVNode as a, createCommentVNode as g } from "vue";
import { useScalarIcon as L } from "../hooks/useScalarIcon.js";
const f = { key: 0 }, k = { key: 1 }, v = { key: 2 }, A = { key: 3 }, V = { key: 4 }, Z = { key: 5 }, h = {
  name: "ScalarIconAsteriskSimple"
}, M = /* @__PURE__ */ p({
  ...h,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const r = s, { bind: d, weight: n } = L(r);
    return (i, l) => (t(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      m(i.$slots, "default"),
      e(n) === "bold" ? (t(), o("g", f, l[0] || (l[0] = [
        a("path", { d: "M212.45,107.14l-65.19,26.08,46.21,59.41a12,12,0,1,1-18.94,14.74L128,147.55,81.47,207.37a12,12,0,0,1-18.94-14.74l46.21-59.41L43.55,107.14a12,12,0,1,1,8.91-22.28L116,110.28V40a12,12,0,0,1,24,0v70.28l63.54-25.42a12,12,0,1,1,8.91,22.28Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (t(), o("g", k, l[1] || (l[1] = [
        a("path", {
          d: "M200,128a72,72,0,1,1-72-72A72,72,0,0,1,200,128Z",
          opacity: "0.2"
        }, null, -1),
        a("path", { d: "M211,103.43l-70.13,28,49.47,63.61a8,8,0,1,1-12.63,9.82L128,141,78.32,204.91a8,8,0,0,1-12.63-9.82l49.47-63.61L45,103.43A8,8,0,0,1,51,88.57l69,27.61V40a8,8,0,0,1,16,0v76.18l69-27.61A8,8,0,1,1,211,103.43Z" }, null, -1)
      ]))) : e(n) === "fill" ? (t(), o("g", v, l[2] || (l[2] = [
        a("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm63.34,91.83-50.4,16.38,31.15,42.87a8,8,0,1,1-12.94,9.4L128,141.61,96.85,184.48a8,8,0,0,1-12.94-9.4l31.15-42.87-50.4-16.38a8,8,0,0,1,4.94-15.22L120,117V64a8,8,0,0,1,16,0v53l50.4-16.38a8,8,0,0,1,4.94,15.22Z" }, null, -1)
      ]))) : e(n) === "light" ? (t(), o("g", A, l[3] || (l[3] = [
        a("path", { d: "M210.23,101.57l-72.6,29,51.11,65.71a6,6,0,0,1-9.48,7.36L128,137.77,76.74,203.68a6,6,0,1,1-9.48-7.36l51.11-65.71-72.6-29a6,6,0,1,1,4.46-11.14L122,119.14V40a6,6,0,0,1,12,0v79.14l71.77-28.71a6,6,0,1,1,4.46,11.14Z" }, null, -1)
      ]))) : e(n) === "regular" ? (t(), o("g", V, l[4] || (l[4] = [
        a("path", { d: "M211,103.43l-70.13,28,49.47,63.61a8,8,0,1,1-12.63,9.82L128,141,78.32,204.91a8,8,0,0,1-12.63-9.82l49.47-63.61L45,103.43A8,8,0,0,1,51,88.57l69,27.61V40a8,8,0,0,1,16,0v76.18l69-27.61A8,8,0,1,1,211,103.43Z" }, null, -1)
      ]))) : e(n) === "thin" ? (t(), o("g", Z, l[5] || (l[5] = [
        a("path", { d: "M209.48,99.71l-75.06,30,52.74,67.8a4,4,0,0,1-.71,5.62A3.93,3.93,0,0,1,184,204a4,4,0,0,1-3.16-1.54L128,134.52,75.16,202.46A4,4,0,0,1,72,204a4,4,0,0,1-2.45-.84,4,4,0,0,1-.71-5.62l52.74-67.8-75.06-30a4,4,0,1,1,3-7.42L124,122.09V40a4,4,0,0,1,8,0v82.09l74.51-29.8a4,4,0,1,1,3,7.42Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  M as default
};
